import "../stylesheets/App.css";
import "../stylesheets/Stage.css";
import React, { useState, useEffect } from "react";
import Header from "./subcomponents/Header.js";
import Game from "./subcomponents/Game.js";
import StageItem from "./subcomponents/StageItem.js";
import Groups from "./subcomponents/Groups.js";
import Loader from "./subcomponents/Loader.js";
import { useNavigate, useParams } from "react-router-dom";
import { manageInfoPopup } from "../utils/ManageInfoPopup.js";
import PopupInfo from "./subcomponents/PopupInfo.js";

function Stage() {
  const navigate = useNavigate();
  const { id } = useParams(); // ✅ idStage desde /stage/:id

  const [loadingGames, setLoadingGames] = useState(true);
  const [loadingBets, setLoadingBets] = useState(true);
  const [loadingStages, setLoadingStages] = useState(true);

  const [refresh, setRefresh] = useState(false);
  const [openInfoPopup, setOpenInfoPopup] = useState(false);

  const [games, setGames] = useState([]);
  const [stage, setStage] = useState({});
  const [bets, setBets] = useState([]);
  const [keywords, setKeywords] = useState("");

  const apiCall = async (url, setter, setLoading, signal) => {
    try {
      const res = await fetch(url, { signal });
      const data = await res.json();
      setter(data.data);
    } catch (e) {
      // si abort -> ignore
      console.log(e);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const raw = localStorage.getItem("user-info");

    // ✅ redirects dentro del effect (no en render)
    if (!raw) {
      navigate("/login");
      return;
    }

    const parsed = JSON.parse(raw);
    if (parsed.is_admin) {
      navigate("/admin");
      return;
    }

    // popup info
    if (manageInfoPopup()) setOpenInfoPopup(true);

    const controller = new AbortController();

    // ✅ traigo stage + bets
    apiCall(
      `${process.env.REACT_APP_API_BASE_URL}/stages/${id}`,
      setStage,
      setLoadingStages,
      controller.signal
    );

    apiCall(
      `${process.env.REACT_APP_API_BASE_URL}/bets/listByUser/${parsed.idUser}`,
      setBets,
      setLoadingBets,
      controller.signal
    );

    // ✅ revisión periódica (1 hora)
    const interval = setInterval(() => {
      if (manageInfoPopup()) setOpenInfoPopup(true);
    }, 60 * 60 * 1000);

    return () => {
      controller.abort();
      clearInterval(interval);
    };
  }, [navigate, id]);

  useEffect(() => {
    const controller = new AbortController();

    setLoadingGames(true);

    const url =
      keywords !== ""
        ? `${process.env.REACT_APP_API_BASE_URL}/games/listByStageWithKeywords/${id}/${keywords}`
        : `${process.env.REACT_APP_API_BASE_URL}/games/listByStage/${id}`;

    apiCall(url, setGames, setLoadingGames, controller.signal);
    setRefresh(false);

    return () => controller.abort();
  }, [keywords, refresh, id]);

  return (
    <>
      <Header keywords={keywords} setKeywords={setKeywords} />

      <section className="stage-page stage-section">
        <StageItem stage={stage} />
      </section>

      <section>
        <h2 className="subtitles">Pronosticá los próximos partidos</h2>

        <ul>
          {stage?.idStage == 1 && keywords === "" ? (
            <Groups bets={bets} />
          ) : (
            games.map((game) =>
              game.teams.length > 0 ? (
                <li key={"li_" + game.idGame}>
                  <Game
                    data={game}
                    bet={bets.find((bet) => bet.game.idGame == game.idGame)}
                    setRefresh={setRefresh}
                  />
                </li>
              ) : (
                ""
              )
            )
          )}
        </ul>
      </section>

      {loadingGames || loadingBets || loadingStages ? <Loader /> : null}

      {openInfoPopup ? (
        <PopupInfo
          title=""
          description="¡Hola! Te recordamos que los pronósticos solo se podrán registrar y guardar con un límite de 15 minutos antes del inicio de cada partido. Si ingresás información después de este límite de tiempo, el pronóstico no será válido y no sumará puntos."
          setOpenPopup={setOpenInfoPopup}
        />
      ) : null}
    </>
  );
}

export default Stage;
